export type AuthConfig = {
  scheme: string;
  accessToken?: string;
};

export type ConfigType = {
  apiUrl: string;
  graphqlUrl: string;
  subscriptionsUrl: string;
  mediaUrl: string;
  /**
   * Origin serving the home-dashboard basemap assets (e.g.
   * https://maps.nonprod.gripp.it): the `us-canada-z12.pmtiles` street archive
   * (fetched via `pmtiles://`), the Natural Earth world-base GeoJSON, and the
   * glyph PBFs. The map renders only when this is set; an empty value (local dev
   * without the env) yields no basemap — point it at a maps origin. Mirrors
   * mediaUrl.
   */
  mapsUrl: string;
  auth: AuthConfig;
  prefix: string;
  version: string;
  sentryDsn: string;
  sentryEnv: string;
  clarityProjectId: string;
  appInsightsConnectionString: string;
};

const EnvConfig: ConfigType = {
  apiUrl: process.env.EXPO_PUBLIC_API_URL || '',
  graphqlUrl: `${process.env.EXPO_PUBLIC_API_URL}/graphql`,
  subscriptionsUrl: `${process.env.EXPO_PUBLIC_API_WS_URL}/graphql`,
  mediaUrl: process.env.EXPO_PUBLIC_MEDIA_URL || '',
  mapsUrl: process.env.EXPO_PUBLIC_MAPS_URL || '',
  prefix: process.env.EXPO_PUBLIC_PREFIX || '',
  auth: {
    scheme: 'gripp',
    accessToken: process.env.EXPO_PUBLIC_TEST_ACCESS_TOKEN,
  },
  version: process.env.EXPO_PUBLIC_VERSION || '...',
  sentryDsn: process.env.EXPO_PUBLIC_SENTRY_DSN || '',
  sentryEnv: process.env.EXPO_PUBLIC_SENTRY_ENV || '',
  clarityProjectId: process.env.EXPO_PUBLIC_CLARITY_PROJECT_ID || '',
  appInsightsConnectionString:
    process.env.EXPO_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING || '',
};

export { EnvConfig };
